import type { FilePublic } from '@repo/types/files';
import type { Dispatch, SetStateAction } from 'react';

import { FileTypeUtils } from '@repo/lib/fs/fileTypeUtils';
import { FileType } from '@repo/types/enums/fileType';

import MediaAudioViewer from '@/components/features/media/MediaAudioViewer';
import MediaFileViewer from '@/components/features/media/MediaFileViewer';
import MediaImageViewer from '@/components/features/media/MediaImageViewer';
import MediaPDFViewer from '@/components/features/media/MediaPDFViewer';
import MediaVideoViewer from '@/components/features/media/MediaVideoViewer';

export interface MediaViewerFile {
  file: FilePublic | File;
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>> | ((bool: boolean) => void);
}

interface MediaViewerProps {
  file?: FilePublic | File;
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>> | ((bool: boolean) => void);
}

export default function MediaViewer(mediaViewerProps: MediaViewerProps) {
  const { file, open, onOpenChange } = mediaViewerProps;
  const { serveType, subtype } = FileTypeUtils.getFileType(file);

  if (!file) {
    return null;
  }

  if (subtype === 'pdf') {
    return <MediaPDFViewer file={file} open={open} onOpenChange={onOpenChange} />;
  } else if (serveType === FileType.IMAGE) {
    return <MediaImageViewer file={file} open={open} onOpenChange={onOpenChange} />;
  } else if (serveType === FileType.VIDEO) {
    return <MediaVideoViewer file={file} open={open} onOpenChange={onOpenChange} />;
  } else if (serveType === FileType.AUDIO) {
    return <MediaAudioViewer file={file} open={open} onOpenChange={onOpenChange} />;
  } else {
    return <MediaFileViewer file={file} open={open} onOpenChange={onOpenChange} />;
  }
}
